
// const root="http://192.168.0.120:5000"
// const root="http://172.168.22.120:5000"
 // const root="http://8.136.113.17:5000"
// const root="http://127.0.0.1:5000"
const root="http://api.lankesports.com"
// const uploadsurl="http://192.168.0.120:5000/uploads/"
// const uploadsurl="http://172.168.22.120:5000/uploads/"
// const uploadsurl="http://127.0.0.1:5000/uploads/"
const uploadsurl="http://api.lankesports.com/uploads/"
// const uploadsurl="http://8.136.113.17:5000/uploads/"
const url={
        uploadsurl:uploadsurl,
        root:root,
      
        admin:{
            goods:{
                "index":root+"/admin/goods/index",
                "add":root+"/admin/goods/add",
                "edit":root+"/admin/goods/edit",
                "delete":root+"/admin/goods/delete",
                "updown":root+"/admin/goods/updown"

            },
            product_group:{

                "index":root+"/admin/product/group/index",
                "add":root+"/admin/product/group/add",
                "edit":root+"/admin/product/group/edit",
                "delete":root+"/admin/product/group/delete",
                "state":root+"/admin/product/group/state"

            },
            product_group_goods:{
                "search":root+"/admin/product/search",
                // "group_search":root+"/admin/product/group/search",
                "group_product_add":root+"/admin/commodity/group/add",
                "group_product_search_index":root+"/admin/product/search/group/index",
                "group_product_search_delete":root+"/admin/product/search/group/delete",
                "group_product_search_edit":root+"/admin/product/search/group/edit",


            },
            product_group_user:{
                "add":root+"/admin/product/group_user/add",
                "index":root+"/admin/product/group_user/index",
                'delete':root+"/admin/product/group_user/delete",
            },
            agent:{
                
                index:root+"/admin/agent/index",
            },
            agent_user:{
                
                index:root+"/admin/agent/user/index",
                add:root+"/admin/agent/user/add",
                edit:root+"/admin/agent/user/edit",
                getagentuser:root+"/admin/agent/user/getagentuser",
                getagentuserlower:root+"/admin/agent/user/lower/level",
            },
            purchase_order:{
                index:root+"/admin/purchase/index",
                add:root+"/admin/purchase/add",
            },
            shop_cart:{
                index:root+"/admin/shop_cart/index",
                add:root+"/admin/shop_cart/add",
            },
            wallet:{

                index:root+"/admin/wallet/user/find",
                add:root+"/admin/wallet/add",
                recharge:root+"/admin/wallet/user/recharge",
            },
            price:{
                "index":root+"/admin/price/index",
                "add":root+"/admin/price/add",
                'agent':root+"/admin/price/agent",
            },
            address:{
                "get_user_address":root+"/admin/address/user/find",
                "add":root+"/admin/address/user/add"
            },
            login:{
            
                setVerify:root+"/admin/generate/token",
                getVerify:root+"/admin/generate/verify_auth_token",
                
               
            },
            member:{
                index:root+"/admin/member/index",
                add:root+"/admin/member/add",
                edit:root+"/admin/member/edit",
                delete:root+"/admin/member/delete",
            },
            category:{
            
                index:root+"/admin/category/index",
                add:root+"/admin/category/add",
                edit:root+"/admin/category/edit",
                delete:root+"/admin/category/delete",
                
                
               
            },
            attr:{
                index:root+"/admin/product_attr/index",
                add:root+"/admin/product_attr/add",
                edit:root+"/admin/product_attr/edit",
                delete:root+"/admin/product_attr/delete"
            },
            area:{
                index:root+"/admin/area/index",
                add:root+"/admin/area/user/add",
                get_user:root+"/admin/area/user",
                list:root+"/admin/area/list",

            },
            order:{
                index:root+"/admin/orders/user/index",
                detail: root+"/admin/orders/user/detail",
                all_index:root+"/admin/orders/user/all/index",
                edit:root+"/admin/orders/user/edit",
            },
            order_service:{

                index:root+"/admin/orders/service/index",
                add:root+"/admin/orders/service/add",
                edit:root+"/admin/orders/service/edit",
                detail: root+"/agent/orders/service/detail",
            },
            attr_name:{
                getList: root+"/admin/product_attr/name/list",
            },
            statistical:{
              info: root+"/admin/statistical/user/info"

            },
            roles:{
                index: root+"/admin/roles/index",
                add: root+"/admin/roles/add",
                edit: root+"/admin/roles/edit",
                delete: root+"/admin/roles/delete"
            },
            withdrawal:{
                
                "index":root+"/admin/withdrawal/user",
                "edit":root+"/admin/withdrawal/user/edit",
      
        },
        order_profits:{

            index:root+"/admin/orders/profits/index",
            detail: root+"/admin/orders/profits/detail",
            settlement:root+"/admin/orders/profits/settlement"
        },
            
        password:{
            index:root+"/admin/account/password/index",
        },
        agent_password:{
                index:root+"/admin/account/agent/password",
        },

        order_payment:{

            index:root+"/admin/payment/user/index",
        },
        product_stock:{

                index:root+"/admin/product/stock/add",
            },
            express:{
                "index":root+"/admin/express/index",
                "edit":root+"/admin/express/edit"

            },
            express_price:{
                "index":root+"/admin/express/price/index",
                "edit":root+"/admin/express/price/edit"

            },
            logistics:{
                "index":root+"/admin/logistics/index",
                "edit":root+"/admin/logistics/edit",
                "add":root+"/admin/logistics/add",
                "delete":root+"/admin/logistics/delete"

            },
        recharge:{
                'index':root+"/admin/recharge/user/index",

                "add":root+"/admin/recharge/user/add",
                "edit":root+"/admin/recharge/user/edit",

            },
            examine:{
                "add":root+"/admin/examine/user/add",

            },
            menu:{
                "add":root+"/admin/menu/add",
                "index":root+"/admin/menu/index",
                "edit":root+"/admin/menu/edit",
                "delete":root+"/admin/menu/delete",
                "permission":root+"/admin/menu/permission",

            },
            roles_menu:{
                "add":root+"/admin/roles/menu/add",
                "index":root+"/admin/roles/menu/index",
            },
            wechat_menu:{
                "index":root+"/admin/wechat/menu/index",
                "add":root+"/admin/wechat/menu/add",
                "edit":root+"/admin/wechat/menu/edit",
                "delete":root+"/admin/wechat/menu/delete",
                "create":root+"/admin/wechat/menu/create",
                "update":root+"/admin/wechat/menu/update",
                "config":root+"/admin/wechat/menu/config",
            },
            article:{
                "index":root+"/admin/article/index",
                "add":root+"/admin/article/add",
                "edit":root+"/admin/article/edit",
                "delete":root+"/admin/article/delete",

            },

        },
        // home:{
        //     index:root+"home/index"
        // },
        // address:{
        //     index:root,
        //     add:root+"address/add/",
        //     edit:root+"address/edit/",
        //     delete:root+"address/delete/",
        //     getData:root+"address/getdata/",
        //     setAddress:root+"address/setaddress/",
        //
        // },
        // register:{
        //     index:root+"register/index/",
        //     getuser:root+"register/getuser/",
        //     getdata:root+"register/getdata/"
        //
        // },
        // goods:{
        //     index:root+"goods/index/",
        //     detail:root+"goods/detail/"
        // },
        // sms:{
        //
        //     getcode:root+"sms/send/"
        //
        // },
        // orders:{
        //     add:root+"orders/add/",
        //     getpay:root+"orders/getpay/",
        // },
        // login:{
        //
        //     setVerify:root+"/generate/token/",
        //     getVerify:root+"login/getVerify/",
        //
        //
        // },
        // password:{
        //     edit:root+"password/edit/",
        // },
        // bankcard:{
        //     index:root+"bankcard/index/",
        //     add:root+"bankcard/add/",
        //     edit:root+"bankcard/edit/",
        //     delete:root+"bankcard/delete/",
        // },
        // orderlist:{
        //     index:root+"orderlist/index/",
        //     add:root+"orderlist/add/",
        //     edit:root+"orderlist/edit/",
        //     delete:root+"orderlist/delete/",
        // },
        // userinfo:{
        //
        //     index:root+"userinfo/index/",
        //
        //     edit:root+"userinfo/edit/",
        // },
        //
        //
        // recommend:{
        //     index:root+"recommend/index/",
        // },
        // wallet:{
        //     index:root+"wallet/index/",
        //     add:root+"wallet/add/",
        //
        // },
        // walletlog:{
        //     index:root+"walletlog/index/",
        //     add:root+"walletlog/add/",
        //
        // },
        // poster:{
        //     getData:root+"Poster/getData/",
        //     index:root+"Poster/index/",
        // },
        // qrcode:{
        //
        //     index:root+"getqrcode/index/",
        // },
        // adver:{
        //     index:root+"adver/index/",
        // },
        // mobile:{
        //
        //     index:root+"mobile/index/",
        // },
       
       

}

export default url;